$w.onReady(function () {
	$w('#columnStrip14').expand();
	$w('#columnStrip15').collapse();

});